module.exports = __webpack_public_path__ + "img/f_2.d387adc9.png";